import { render, staticRenderFns } from "./AnswersShow.vue?vue&type=template&id=61b7d275&scoped=true&"
import script from "./AnswersShow.vue?vue&type=script&lang=js&"
export * from "./AnswersShow.vue?vue&type=script&lang=js&"
import style0 from "./AnswersShow.vue?vue&type=style&index=0&id=61b7d275&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b7d275",
  null
  
)

export default component.exports